import React, {MouseEvent, useRef, useState} from 'react';
import classNames from 'classnames';
import {observer} from "mobx-react-lite";
import {useAppState} from "@stores/AppStateContext";

import {NotificationBadge} from "./NotificationBadge";
import {NotificationIcon} from "../../../components/icons/NotificationIcon";
import {openNotificationCentre} from "./openNotificationCentre";

interface NotificationButtonProps {
    className?: string;
}

export const NotificationButton = observer(({className}: NotificationButtonProps) => {
    const appState = useAppState();
    const rootStore = appState.rootStore;
    const userState = appState.userState;
    const ref = useRef<HTMLElement | null>(null);
    const [isNotificationOpen, setNotificationOpen] = useState(false);

    return (
        <NotificationBadge
            invisible={!rootStore.isReady
                || !userState?.dsManager?.notificationsDS?.isInitialized
                || userState!.dsManager!.notificationsDS.filteredRows.filter((ntf) => ntf.status === 'unread').length === 0
            }
        >
            <NotificationIcon
                className={classNames({
                    "Notification_button": true,
                    "Notification_button--open": isNotificationOpen,
                    [className!]: className,
                })}
                size={24}
                ref={ref}
                onClick={(event: MouseEvent<HTMLElement>) => {
                    event.stopPropagation();
                    if (ref.current) {
                        openNotificationCentre(appState, {
                            targetDom: ref.current,
                            event: event,
                            setIsOpen: setNotificationOpen,
                            withOverlay: true,
                        });
                    }
                }}
            />
        </NotificationBadge>
    );
});
